import { Absence } from "../../API";
import { gqlQuery, QueryType, toDbDates } from "../../lib";

type QueryProps = {
  id: string;
  dates: Interval | null;
};

export const absencesReportQuery =
  ({ dates, id }: QueryProps) =>
  (input: Omit<QueryType, "req">) => {
    if (dates === null) {
      throw new Error(`Incorrect date range. Value is ${dates}`);
    }
    const dateRange = toDbDates(dates);

    const { queryFn: listAbsencesQueryFn, queryKey } = gqlQuery({
      req: "listAbsences",
      vars: {
        filter:
          id.length > 0
            ? {
                employeeID: { contains: id },
                startDate: { ge: dateRange[0] },
                endDate: { le: dateRange[1] },
              }
            : {
                startDate: { ge: dateRange[0] },
                endDate: { le: dateRange[1] },
              },
        ...input.vars,
        ...(id.length > 0 && { id }),
      },
      key: id
        ? [dateRange, { id }, ...(input.key ?? [])]
        : [dateRange, ...(input.key ?? [])],
    });

    return {
      queryKey,
      queryFn: async () => {
        const { data: absenceData, errors: absenceErrors = [] } =
          await listAbsencesQueryFn();

        return {
          items: absenceData?.listAbsences?.items as Absence[],
          errors: [...absenceErrors],
          nextToken: absenceData?.listAbsences?.nextToken,
        };
      },
    };
  };
